import KeyUtility from "@/util/keyUtility";
import LoginInfo from "@/util/LoginInfo";
import AccountDataAES from "@/util/accountDataAES";

export default class PersistentLogin {

    public static STORAGE_KEY_KEY: string = "userMasterKey";
    public static STORAGE_KEY_HASH: string = "userAuthHash";
    public static STORAGE_KEY_NAME: string = "username";

    public static async saveLogin(masterKey: CryptoKey, authHash: string, username: string, persistent: boolean): Promise<void> {

        const keyAsB64: string = await KeyUtility.exportKeyToBase64(masterKey);
        if (persistent) {
            localStorage.setItem(PersistentLogin.STORAGE_KEY_KEY, keyAsB64);
            localStorage.setItem(PersistentLogin.STORAGE_KEY_HASH, authHash);
            localStorage.setItem(PersistentLogin.STORAGE_KEY_NAME, username);
        } else {
            sessionStorage.setItem(PersistentLogin.STORAGE_KEY_KEY, keyAsB64);
            sessionStorage.setItem(PersistentLogin.STORAGE_KEY_HASH, authHash);
            sessionStorage.setItem(PersistentLogin.STORAGE_KEY_NAME, username);
        }
    }

    public static async getLogin(): Promise<LoginInfo | null> {

        //check persistent first:

        let keyAsB64: string | null = localStorage.getItem(PersistentLogin.STORAGE_KEY_KEY);
        let username: string | null = localStorage.getItem(PersistentLogin.STORAGE_KEY_NAME);
        let authHash: string | null = localStorage.getItem(PersistentLogin.STORAGE_KEY_HASH);

        if (!keyAsB64) {
            keyAsB64 = sessionStorage.getItem(PersistentLogin.STORAGE_KEY_KEY);
            authHash = sessionStorage.getItem(PersistentLogin.STORAGE_KEY_HASH);
            username = sessionStorage.getItem(PersistentLogin.STORAGE_KEY_NAME);
        }

        if (!keyAsB64 || !username || !authHash) {
            return null;
        }

        const key: CryptoKey = await AccountDataAES.loadKeyFromBase64(keyAsB64);
        const info: LoginInfo = new LoginInfo();
        info.masterKey = key;
        info.username = username;
        info.authHash = authHash;

        return info;
    }

    public static deleteInformation() {
        sessionStorage.removeItem(PersistentLogin.STORAGE_KEY_KEY);
        sessionStorage.removeItem(PersistentLogin.STORAGE_KEY_HASH);
        sessionStorage.removeItem(PersistentLogin.STORAGE_KEY_NAME);

        localStorage.removeItem(PersistentLogin.STORAGE_KEY_KEY);
        localStorage.removeItem(PersistentLogin.STORAGE_KEY_HASH);
        localStorage.removeItem(PersistentLogin.STORAGE_KEY_NAME);
    }

}
